import Vesting from './Vesting'

export default Vesting